import React, {
  ReactElement,
  Component,
  Dispatch,
  SetStateAction,
  useContext
} from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import {Modal} from 'antd'

// 全局变量
import {NoPermissionVisibleContext} from '../contexts/no-permission-visible';
import {cry} from '../../../img';



const NoPermissionModal: React.FC = (): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const [no_permission_visible, set_no_permission_visible]: [boolean, Dispatch<SetStateAction<boolean>>] = useContext(NoPermissionVisibleContext);

  return (
    <Modal
      visible={no_permission_visible}
      width={780}
      footer={null}
      centered={true}
      onCancel={() => set_no_permission_visible(false)}
      className="norole_modal"
    >
      <div className="no_role_div">
        <img src={cry} alt="sorry" />
        <span className="px-20"><FormattedMessage id="sorry_no_subscription_permission" /></span>
      </div>
    </Modal>
  )
};

export default injectIntl(NoPermissionModal);
